import { Autocomplete, TextField } from "@mui/material";
import isString from "lodash/isString";
import type { FC } from "react";

interface TagInputProps {
  readonly suggestions: string[];
  readonly tags: string[];
  readonly label: string;
  readonly multiple: boolean;
  readonly size?: "small" | "medium";
  readonly fullWidth?: boolean;
  readonly onChange: (tags: string[]) => void;
}

const TagInput: FC<TagInputProps> = ({ tags = [], suggestions, size, label, fullWidth, onChange }) => {
  const options = suggestions.filter(isString);
  return (
    <Autocomplete
      multiple
      freeSolo
      fullWidth={fullWidth}
      size={size}
      id="tags-outlined"
      options={options}
      value={tags}
      onChange={(e, newValue) => onChange(newValue)}
      filterSelectedOptions
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};

export default TagInput;
